import {
  Directive,
  inject,
  TemplateRef,
  ViewContainerRef
} from "@angular/core";

@Directive({
  selector: "[editableTemplateSelectBoxItem]",
  standalone: false
})
export class EditableSelectBoxItemTemplateDirective {
  templateRef = inject(TemplateRef);
  viewContainer = inject(ViewContainerRef);
}
